import React from "react"
import PropTypes from "prop-types"
import get from 'lodash/get'
import Helmet from 'react-helmet'
import PostSummary from '../components/PostSummary'
import Heading from '../components/Heading'
import SideMenu from '../components/SideMenu'
import { Col } from 'reactstrap';


class Tags extends React.Component {
  render() {
    const tag = this.props.pathContext.tag
    const posts = this.props.data.allMarkdownRemark.edges
    const title = `All Posts tagged as "${tag.charAt(0).toUpperCase() + tag.substr(1).toLowerCase()}"`


    return (
      <SideMenu >
      <Helmet title={title} />
      <Col xs="12" lg={{ size: 10 }} xl={{ size: 8 }}>
        <Heading marginBottom={1.5}>{title} </Heading>
        {posts.map(({ node }) => {
          const title = get(node, 'frontmatter.title') || node.fields.slug
          return (
            <PostSummary key={node.fields.slug}
              slug={node.fields.slug}
              title={title}
              date={node.frontmatter.date}
              excerpt={node.excerpt} />
          )
        })}
      </Col>
    </SideMenu >
    )
  }
}
Tags.propTypes = {
  pageContext: PropTypes.shape({
    tag: PropTypes.string.isRequired,
  }),
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      totalCount: PropTypes.number.isRequired,
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            frontmatter: PropTypes.shape({
              path: PropTypes.string.isRequired,
              title: PropTypes.string.isRequired,
            }),
          }),
        }).isRequired
      ),
    }),
  }),
}
export default Tags

export const pageQuery = graphql`
  query BlogPostsByTag($tag: String) {
    allMarkdownRemark(
      limit: 2000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/templates/tags.js